import { Columns } from '@zmedia/bm-soccer-ui/components';
import { memo, useCallback } from 'react';
import { ITransfer } from '@zmedia/bm-soccer-ui/interface';
import { TransferItem } from '../item';
import styles from './style.module.scss';

interface IProps {
    items: ITransfer[];
}
export function TransferList({ items = [] }: IProps) {
    const renderItem = (item: ITransfer, index: number) => {
        return (
            <Columns.Column key={index}>
                <TransferItem key={index} item={item} />
            </Columns.Column>
        );
    };

    const renderItems = useCallback(() => {
        return items.map((item, index) => {
            return renderItem(item, index);
        });
    }, [items]);

    return (
        <Columns className={styles['column-transfer']}>{renderItems()}</Columns>
    );
}

export default memo(TransferList);
